class Breadcrumb extends HTMLElement {
    static observedAttributes = [];

    constructor() {
        super();
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this.dynamicRender();
    }

    connectedCallback() {
        this.attachShadow({mode: 'open'});

        // Append site stylesheet
        const styleSheet = document.createElement('link');
        styleSheet.setAttribute('rel', 'stylesheet');
        styleSheet.setAttribute('href', '/dist/style.css');
        this.shadowRoot.appendChild(styleSheet);

        this._wrapper = document.createElement('div');
        this._wrapper.className = 'breadcrumb-wrapper';
        this.shadowRoot.appendChild(this._wrapper);

        const slot = `<slot></slot>`;

        this._wrapper.insertAdjacentHTML('beforeend', slot);
        this._slot = this._wrapper.querySelector('slot');

        this.dynamicRender();
    }

    setupEvents() {

    }

    dynamicRender() {
        if (!!this._wrapper) return;

    }}

customElements.define('bread-crumb', Breadcrumb);

